export async function getStripePlans(db) {
  const plans = { monthlyPlans: [], yearlyPlans: [], hiddenMonthlyPlans: [], hiddenYearlyPlans: [] };
  const querySnapshot = await db.collection('stripePlans').get();
  querySnapshot.forEach(doc => {
    const plan = doc.data();
    if (plan.isYearly) {
      if (plan.isHidden) {
        plans.hiddenYearlyPlans.push(plan)
      } else {
        plans.yearlyPlans.push(plan)
      }
    } else {
      if (plan.isHidden) {
        plans.hiddenMonthlyPlans.push(plan)
      } else {
        plans.monthlyPlans.push(plan)
      }
    }
  });
  return plans;
}


